module.exports = __webpack_public_path__ + "img/go-with-freedom-mobile.be0ad06f.png";